import { Grid } from "@material-ui/core";
import React from "react";
import "./Logo.css";

const imageName = [
  "api",
  "jss",
  "js",
  "csss",
  "csharp",
  "react",
  "redux",
  "mui",
  "sql",
  "firebase",
  // "flutter",
  // "mern",
];

function Logo() {
  return (
    <div className="logo">
      <Grid container spacing={2}>
        {imageName?.map((each) => (
          <Grid className="eachLogo" item xs={6} md={4} lg={3} xl={2}>
            <img className="logo_image" src={`/images/${each}.png`} alt="js" />
          </Grid>
        ))}
      </Grid>
      {/* <img className="logo_image" src="/images/js.png" alt="js" />
      <img className="logo_image" src="/images/html.png" alt="js" />
      <img className="logo_image" src="/images/css.png" alt="js" />
      <img className="logo_image" src="/images/csharp.png" alt="js" />
      <img className="logo_image" src="/images/react.png" alt="js" />
      <img className="logo_image" src="/images/redux.png" alt="js" />
      <img className="logo_image" src="/images/mui.png" alt="js" />
      <img className="logo_image" src="/images/sql.png" alt="js" />
      <img className="logo_image" src="/images/firebase.png" alt="js" />
      <img className="logo_image" src="/images/flutter.png" alt="js" />
      <img className="logo_image" src="/images/mern.png" alt="js" /> */}
    </div>
  );
}

export default Logo;
